import styled from "@emotion/styled";
import { Link } from "@xometry/xometry_loft";
import theme from "../../../../styles/theme";

export const HelpCenterHitBase = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${theme.largerThan.md} {
    gap: 16px;
    flex-direction: row;
  }
`;

export const TextWrapper = styled.div``;

export const TitleWrapper = styled(Link)``;

export const TitleText = styled.div`
  display: block;
  color: ${theme.colors.blues[125]};
  font-size: 16px;
  line-height: 24px;

  ${theme.largerThan.md} {
    font-size: 21px;
  }
`;

export const URL = styled.div`
  display: inline-block;
  color: ${theme.colors.darkBlues[75]};
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 4px;
`;

export const Description = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  ${theme.largerThan.md} {
    font-size: 16px;
    line-height: 24px;
    -webkit-line-clamp: 3;
  }
`;
